module.exports =
/******/
function (modules) {
  // webpackBootstrap

  /******/
  // The module cache

  /******/
  var installedModules = {};
  /******/

  /******/
  // The require function

  /******/

  function __webpack_require__(moduleId) {
    /******/

    /******/
    // Check if module is in cache

    /******/
    if (installedModules[moduleId]) {
      /******/
      return installedModules[moduleId].exports;
      /******/
    }
    /******/
    // Create a new module (and put it into the cache)

    /******/


    var module = installedModules[moduleId] = {
      /******/
      i: moduleId,

      /******/
      l: false,

      /******/
      exports: {}
      /******/

    };
    /******/

    /******/
    // Execute the module function

    /******/

    modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
    /******/

    /******/
    // Flag the module as loaded

    /******/

    module.l = true;
    /******/

    /******/
    // Return the exports of the module

    /******/

    return module.exports;
    /******/
  }
  /******/

  /******/

  /******/
  // expose the modules object (__webpack_modules__)

  /******/


  __webpack_require__.m = modules;
  /******/

  /******/
  // expose the module cache

  /******/

  __webpack_require__.c = installedModules;
  /******/

  /******/
  // define getter function for harmony exports

  /******/

  __webpack_require__.d = function (exports, name, getter) {
    /******/
    if (!__webpack_require__.o(exports, name)) {
      /******/
      Object.defineProperty(exports, name, {
        /******/
        configurable: false,

        /******/
        enumerable: true,

        /******/
        get: getter
        /******/

      });
      /******/
    }
    /******/

  };
  /******/

  /******/
  // getDefaultExport function for compatibility with non-harmony modules

  /******/


  __webpack_require__.n = function (module) {
    /******/
    var getter = module && module.__esModule ?
    /******/
    function getDefault() {
      return module['default'];
    } :
    /******/
    function getModuleExports() {
      return module;
    };
    /******/

    __webpack_require__.d(getter, 'a', getter);
    /******/


    return getter;
    /******/
  };
  /******/

  /******/
  // Object.prototype.hasOwnProperty.call

  /******/


  __webpack_require__.o = function (object, property) {
    return Object.prototype.hasOwnProperty.call(object, property);
  };
  /******/

  /******/
  // __webpack_public_path__

  /******/


  __webpack_require__.p = "";
  /******/

  /******/
  // Load entry module and return exports

  /******/

  return __webpack_require__(__webpack_require__.s = 2);
  /******/
}(
/************************************************************************/

/******/
[
/* 0 */

/***/
function (module, exports) {
  module.exports = require("react");
  /***/
},
/* 1 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var React = __webpack_require__(0);

  var IconNoWeb3 = __webpack_require__(8);

  var stylesheet = __webpack_require__(9);

  function ErrorTemplate(props) {
    return React.createElement('div', {
      className: 'Web3Provider-container'
    }, React.createElement('style', {
      dangerouslySetInnerHTML: {
        __html: stylesheet
      }
    }), React.createElement('div', {
      className: 'Web3Provider-wrapper'
    }, React.createElement('div', {
      className: 'Web3Provider-image'
    }, React.createElement(IconNoWeb3, null)), React.createElement('h1', {
      className: 'Web3Provider-title',
      dangerouslySetInnerHTML: {
        __html: props.title
      }
    }), React.createElement('p', {
      className: 'Web3Provider-message',
      dangerouslySetInnerHTML: {
        __html: props.message
      }
    })));
  }

  module.exports = ErrorTemplate;
  /***/
},
/* 2 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var Web3Provider = __webpack_require__(3);

  var ErrorTemplate = __webpack_require__(1);

  module.exports.Web3Provider = Web3Provider;
  module.exports.ErrorTemplate = ErrorTemplate;
  module.exports = {
    Web3Provider: Web3Provider,
    ErrorTemplate: ErrorTemplate
  };
  /***/
},
/* 3 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var React = __webpack_require__(0);

  var PropTypes = __webpack_require__(4);

  var isEmpty = __webpack_require__(5);

  var range = __webpack_require__(6);

  var AccountUnavailable = __webpack_require__(7);

  var Web3Unavailable = __webpack_require__(10);

  var ONE_SECOND = 1000;
  var ONE_MINUTE = ONE_SECOND * 60;
  var propTypes = {
    web3UnavailableScreen: PropTypes.any,
    accountUnavailableScreen: PropTypes.any,
    onChangeAccount: PropTypes.func
  };
  var defaultProps = {
    passive: false,
    web3UnavailableScreen: Web3Unavailable,
    accountUnavailableScreen: AccountUnavailable
  };
  var childContextTypes = {
    web3: PropTypes.shape({
      accounts: PropTypes.array,
      selectedAccount: PropTypes.string,
      network: PropTypes.string,
      networkId: PropTypes.number
    })
  };

  var Web3Provider = function (_React$Component) {
    _inherits(Web3Provider, _React$Component);

    function Web3Provider(props, context) {
      _classCallCheck(this, Web3Provider);

      var _this = _possibleConstructorReturn(this, (Web3Provider.__proto__ || Object.getPrototypeOf(Web3Provider)).call(this, props, context));

      var accounts = _this.getAccounts();

      _this.state = {
        accounts: accounts,
        networkId: null,
        networkError: null
      };
      _this.interval = null;
      _this.networkInterval = null;
      _this.fetchAccounts = _this.fetchAccounts.bind(_this);
      _this.fetchNetwork = _this.fetchNetwork.bind(_this);

      if (accounts) {
        _this.handleAccounts(accounts, true);
      }

      return _this;
    }

    _createClass(Web3Provider, [{
      key: 'getChildContext',
      value: function getChildContext() {
        return {
          web3: {
            accounts: this.state.accounts,
            selectedAccount: this.state.accounts && this.state.accounts[0],
            network: getNetwork(this.state.networkId),
            networkId: this.state.networkId
          }
        };
      }
      /**
       * Start polling accounts, & network. We poll indefinitely so that we can
       * react to the user changing accounts or netowrks.
       */

    }, {
      key: 'componentDidMount',
      value: function componentDidMount() {
        this.fetchAccounts();
        this.fetchNetwork();
        this.initPoll();
        this.initNetworkPoll();
      }
      /**
       * Init web3/account polling, and prevent duplicate interval.
       * @return {void}
       */

    }, {
      key: 'initPoll',
      value: function initPoll() {
        if (!this.interval) {
          this.interval = setInterval(this.fetchAccounts, ONE_SECOND);
        }
      }
      /**
       * Init network polling, and prevent duplicate intervals.
       * @return {void}
       */

    }, {
      key: 'initNetworkPoll',
      value: function initNetworkPoll() {
        if (!this.networkInterval) {
          this.networkInterval = setInterval(this.fetchNetwork, ONE_MINUTE);
        }
      }
      /**
       * Update state regarding the availability of web3 and an ETH account.
       * @return {void}
       */

    }, {
      key: 'fetchAccounts',
      value: function fetchAccounts() {
        var _this2 = this;

        var _window = window,
            web3 = _window.web3;
        var ethAccounts = this.getAccounts();

        if (isEmpty(ethAccounts)) {
          web3 && web3.currentProvider && web3.currentProvider.enable().then(function (accounts) {
            return _this2.handleAccounts(accounts);
          }).catch(function (err) {
            _this2.setState({
              accountsError: err
            });
          });
        } else {
          this.handleAccounts(ethAccounts);
        }
      }
    }, {
      key: 'handleAccounts',
      value: function handleAccounts(accounts) {
        var isConstructor = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        var onChangeAccount = this.props.onChangeAccount;
        var store = this.context.store;
        var next = accounts[0];
        var curr = this.state.accounts[0];
        next = next && next.toLowerCase();
        curr = curr && curr.toLowerCase();
        var didChange = curr && next && curr !== next;

        if (isEmpty(this.state.accounts) && !isEmpty(accounts)) {
          this.setState({
            accountsError: null,
            accounts: accounts
          });
        }

        if (didChange && !isConstructor) {
          this.setState({
            accountsError: null,
            accounts: accounts
          });
        } // If provided, execute callback


        if (didChange && typeof onChangeAccount === 'function') {
          onChangeAccount(next);
        } // If available, dispatch redux action


        if (store && typeof store.dispatch === 'function') {
          var didLogin = !curr && next;
          var didLogout = curr && !next;

          if (didLogout) {
            store.dispatch({
              type: 'web3/LOGOUT',
              address: null
            });
          } else if (didLogin || isConstructor && next) {
            store.dispatch({
              type: 'web3/RECEIVE_ACCOUNT',
              address: next
            });
          } else if (didChange) {
            store.dispatch({
              type: 'web3/CHANGE_ACCOUNT',
              address: next
            });
          }
        }
      }
      /**
       * Get the network and update state accordingly.
       * @return {void}
       */

    }, {
      key: 'fetchNetwork',
      value: function fetchNetwork() {
        var _this3 = this;

        var _window2 = window,
            web3 = _window2.web3;

        if (web3) {
          var isV1 = /^1/.test(web3.version);

          var _getNetwork = isV1 ? web3.eth.net.getId : web3.version.getNetwork;

          _getNetwork(function (err, netId) {
            if (err) {
              _this3.setState({
                networkError: err
              });
            } else {
              if (netId != _this3.state.networkId) {
                _this3.setState({
                  networkError: null,
                  networkId: netId
                });
              }
            }
          });
        }
      }
      /**
       * Get the account. We wrap in try/catch because reading `web3.eth.accounts`
       * will throw if no account is selected.
       * @return {String}
       */

    }, {
      key: 'getAccounts',
      value: function getAccounts() {
        var _window3 = window,
            web3 = _window3.web3;

        try {
          var _window4 = window,
              _web = _window4.web3;
          var isV1 = /^1/.test(_web.version); // throws if no account selected

          var getV1Wallets = function getV1Wallets() {
            return range(_web.eth.accounts.wallet.length).map(function (i) {
              return _web.eth.accounts.wallet[i];
            }).map(function (w) {
              return w.address;
            });
          };

          var accounts = isV1 ? getV1Wallets() : _web.eth.accounts;
          return accounts;
        } catch (e) {
          return [];
        }
      }
    }, {
      key: 'render',
      value: function render() {
        var _window5 = window,
            web3 = _window5.web3;
        var _props = this.props,
            passive = _props.passive,
            Web3UnavailableComponent = _props.web3UnavailableScreen,
            AccountUnavailableComponent = _props.accountUnavailableScreen;

        if (passive) {
          return this.props.children;
        }

        if (!web3) {
          return React.createElement(Web3UnavailableComponent, null);
        }

        if (isEmpty(this.state.accounts)) {
          return React.createElement(AccountUnavailableComponent, null);
        }

        return this.props.children;
      }
    }]);

    return Web3Provider;
  }(React.Component);

  Web3Provider.contextTypes = {
    store: PropTypes.object
  };
  Web3Provider.propTypes = propTypes;
  Web3Provider.defaultProps = defaultProps;
  Web3Provider.childContextTypes = childContextTypes;
  module.exports = Web3Provider;
  /* =============================================================================
  =    Deps
  ============================================================================= */

  function getNetwork(networkId) {
    switch (networkId) {
      case '1':
        return 'MAINNET';

      case '2':
        return 'MORDEN';

      case '3':
        return 'ROPSTEN';

      case '4':
        return 'RINKEBY';

      case '42':
        return 'KOVAN';

      default:
        return 'UNKNOWN';
    }
  }
  /***/

},
/* 4 */

/***/
function (module, exports) {
  module.exports = require("prop-types");
  /***/
},
/* 5 */

/***/
function (module, exports) {
  module.exports = require("lodash/isEmpty");
  /***/
},
/* 6 */

/***/
function (module, exports) {
  module.exports = require("lodash/range");
  /***/
},
/* 7 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var React = __webpack_require__(0);

  var ErrorTemplate = __webpack_require__(1);

  var AccountUnavailable = ErrorTemplate.bind(null, {
    title: 'No ETH Account Available',
    message: '\nIt seems that you don&apos;t have an ETH account selected. If using\nMetaMask, please make sure that your wallet is unlocked and that\nyou have at least one account in your accounts list.'
  });
  module.exports = AccountUnavailable;
  /***/
},
/* 8 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var _react = __webpack_require__(0);

  var _react2 = _interopRequireDefault(_react);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function IconNoWeb3(props) {
    return _react2.default.createElement("svg", {
      width: "100%",
      height: "100%",
      viewBox: "0 0 332 417",
      version: "1.1",
      xmlns: "http://www.w3.org/2000/svg",
      xmlnsXlink: "http://www.w3.org/1999/xlink"
    }, _react2.default.createElement("defs", null, _react2.default.createElement("path", {
      d: "M198.610685,43.1017808 C107.24977,43.1017808 33.1017808,117.24977 33.1017808,208.610685 C33.1017808,299.971599 107.24977,374.119588 198.610685,374.119588 C289.971599,374.119588 364.119588,299.971599 364.119588,208.610685 C364.119588,117.24977 289.971599,43.1017808 198.610685,43.1017808 L198.610685,43.1017808 Z M198.610685,341.017808 C125.455749,341.017808 66.2035615,281.76562 66.2035615,208.610685 C66.2035615,177.991537 76.6306225,149.855024 94.1745663,127.511322 L279.710047,313.046803 C257.366345,330.590747 229.229832,341.017808 198.610685,341.017808 L198.610685,341.017808 Z M303.046803,289.710047 L117.511322,104.174566 C139.855024,86.6306225 167.991537,76.2035615 198.610685,76.2035615 C271.76562,76.2035615 331.017808,135.455749 331.017808,208.610685 C331.017808,239.229832 320.590747,267.366345 303.046803,289.710047 L303.046803,289.710047 Z",
      id: "path-1"
    })), _react2.default.createElement("g", {
      id: "Page-1",
      stroke: "none",
      strokeWidth: "1",
      fill: "none",
      fillRule: "evenodd"
    }, _react2.default.createElement("g", {
      id: "Group",
      transform: "translate(-33.000000, 0.000000)"
    }, _react2.default.createElement("g", {
      id: "Ethereum_logo_2014",
      opacity: "0.208899457",
      transform: "translate(71.000000, 0.000000)",
      fillRule: "nonzero"
    }, _react2.default.createElement("polygon", {
      id: "Shape",
      fill: "#343434",
      points: "127.9611 0 125.1661 9.5 125.1661 285.168 127.9611 287.958 255.9231 212.32"
    }), _react2.default.createElement("polygon", {
      id: "Shape",
      fill: "#8C8C8C",
      points: "127.962 0 0 212.32 127.962 287.959 127.962 154.158"
    }), _react2.default.createElement("polygon", {
      id: "Shape",
      fill: "#3C3C3B",
      points: "127.9611 312.1866 126.3861 314.1066 126.3861 412.3056 127.9611 416.9066 255.9991 236.5866"
    }), _react2.default.createElement("polygon", {
      id: "Shape",
      fill: "#8C8C8C",
      points: "127.962 416.9052 127.962 312.1852 0 236.5852"
    }), _react2.default.createElement("polygon", {
      id: "Shape",
      fill: "#141414",
      points: "127.9611 287.9577 255.9211 212.3207 127.9611 154.1587"
    }), _react2.default.createElement("polygon", {
      id: "Shape",
      fill: "#393939",
      points: "0.0009 212.3208 127.9609 287.9578 127.9609 154.1588"
    })), _react2.default.createElement("g", {
      id: "ic_do_not_disturb",
      transform: "translate(0.000000, 10.000000)"
    }), _react2.default.createElement("polygon", {
      id: "Bounds",
      points: "0 10 397.221369 10 397.221369 407.221369 0 407.221369"
    }), _react2.default.createElement("g", {
      id: "Icon"
    }, _react2.default.createElement("use", {
      fill: "#FFE1DE",
      fillRule: "evenodd",
      xlinkHref: "#path-1"
    }), _react2.default.createElement("path", {
      stroke: "#FFFFFF",
      strokeWidth: "6",
      d: "M198.610685,46.1017808 C288.314745,46.1017808 361.119588,118.906624 361.119588,208.610685 C361.119588,298.314745 288.314745,371.119588 198.610685,371.119588 C108.906624,371.119588 36.1017808,298.314745 36.1017808,208.610685 C36.1017808,118.906624 108.906624,46.1017808 198.610685,46.1017808 Z M198.610685,344.017808 C123.798895,344.017808 63.2035615,283.422474 63.2035615,208.610685 C63.2035615,178.077442 73.3736714,149.145233 91.8150049,125.658629 L93.9040007,122.998115 L284.223254,313.317368 L281.56274,315.406364 C258.076136,333.847698 229.143927,344.017808 198.610685,344.017808 Z M303.317368,294.223254 L112.998115,103.904001 L115.658629,101.815005 C139.145233,83.3736714 168.077442,73.2035615 198.610685,73.2035615 C273.422474,73.2035615 334.017808,133.798895 334.017808,208.610685 C334.017808,239.143927 323.847698,268.076136 305.406364,291.56274 L303.317368,294.223254 Z"
    })))));
  }

  module.exports = IconNoWeb3;
  /***/
},
/* 9 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  module.exports = "\n.Web3Provider-container {\n  font-family: Helvetica, Arial;\n  color: hsl(0,0%,50%);\n  position: relative;\n  width: 100%;\n  height: 100%;\n  text-align: center;\n  background: hsl(0, 0%, 95%);\n  background: -webkit-linear-gradient(hsl(0, 0%, 100%), hsl(0, 0%, 95%));\n  background: -moz-linear-gradient(hsl(0, 0%, 100%), hsl(0, 0%, 95%));\n  background: -o-linear-gradient(hsl(0, 0%, 100%), hsl(0, 0%, 95%));\n  background: linear-gradient(hsl(0, 0%, 100%), hsl(0, 0%, 95%));\n}\n.Web3Provider-wrapper {\n  width: 400px;\n  border: 1px solid hsl(207, 90%, 54%);\n  border-radius: 20px;\n  text-align: center;\n  padding: 50px 40px;\n  margin: 80px auto;\n}\n.Web3Provider-image {\n  max-height: 175px;\n}\n.Web3Provider-title {\n  margin-top: 50px;\n  color: hsl(0,0%,25%);\n}\n.Web3Provider-message {\n  line-height: 27px;\n  font-size: 18px;\n  color: hsl(0,0%,50%);\n}\n";
  /***/
},
/* 10 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var React = __webpack_require__(0);

  var ErrorTemplate = __webpack_require__(1);

  var Web3Unavailable = ErrorTemplate.bind(null, {
    title: 'Web3 Not Found',
    message: '\nIt seems that you are using a browser without Web3 capabilities. Please\nmake sure that you are using a web3-capable browser like mist or parity.\nIf you are using MetaMask or Parity extension, make sure that it is\nenabled.\n'
  });
  module.exports = Web3Unavailable;
  /***/
}]);